exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".ContentModal___BtII_ .am-modal-transparent___xS0H2 {\n  width: 100vw;\n}\n.ContentModal___BtII_ {\n  width: 100vw !important;\n}", ""]);

// exports
exports.locals = {
	"ContentModal": "ContentModal___BtII_",
	"am-modal-transparent": "am-modal-transparent___xS0H2"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"importLoaders":1,"localIdentName":"[local]___[hash:base64:5]"}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/views/activity_41/components/styles.css
// module id = 966
// module chunks = 0